package horcrux.frontend.common.views.collections.collectiondialogs

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.extensions.chatPageBrowserAppURL
import horcrux.frontend.common.views.collections.CollectionNavigatorMenuOption
import horcrux.frontend.common.views.collections.editcollectionmenu.EditChatPageCollectionMenu
import horcrux.frontend.common.views.collections.navigator.ChatPageCollectionSelector
import horcrux.frontend.common.views.components.containers.DialogView
import horcrux.frontend.common.views.components.containers.HStack
import kotlinx.browser.window
import mui.material.DialogContentText
import mui.material.DialogTitle
import mui.material.Link
import mui.system.sx
import react.FC
import react.Props
import web.cssom.pt

external interface ManageChatPagesDialogProps : Props {
    var globalAppState: GlobalAppState
}

val ManageChatPagesDialog = FC<ManageChatPagesDialogProps> { props ->
    DialogView {
        this.title = CollectionNavigatorMenuOption.EDIT_CHAT_PAGES.viewName
        this.showDialogState = props.globalAppState.collectionNavigatorState.showManagePublicCollectionsState
        DialogTitle {
            +CollectionNavigatorMenuOption.EDIT_CHAT_PAGES.viewName
        }
        DialogContentText {
            +"These are your public chat pages. You can create one by beginning a chat with The Grok App and clicking the \"Publish\" button next the response message. By doing that you make public the documents in your collection and any chat history above and including that message. You will then receive a link you can use to share your chat page."
        }
        HStack {
            this.sx {
                this.marginTop = 5.pt
            }
            ChatPageCollectionSelector {
                this.globalAppState = props.globalAppState
            }
            EditChatPageCollectionMenu {
                this.globalAppState = props.globalAppState
            }
        }
        props.globalAppState.currentChatPageMetadataMaybeState.get()?.let {
            Link {
                val url = it.id.chatPageBrowserAppURL
                +"Click to view your chat page"
                this.href = url
                this.onClick = {
                    it.preventDefault()
                    window.open(url, "_blank", "noreferrer")
                }
            }
        }
    }
}
